import script from "./MobileUserMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileUserMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"MobileUserMenu.vue"]])

export default __exports__